
    /**
     * Round number to a specific radix
     */
    function round(value, radix){
        radix = radix || 1; // default round 1
        return Math.round(value / radix) * radix;
    }

    module.exports = round;





//////////////////
// WEBPACK FOOTER
// ./~/mout/math/round.js
// module id = 1621
// module chunks = 0 1 2